import React, { Component } from 'react';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';

class QuestionDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            message: '',
            type: 'success',
            id: null
        };

        this.open = this.open.bind(this);
    }

    open = (message, id) =>{
        this.setState({
            show:true, message, id
        })
    };

    render() {
        return (
            <SweetAlert
                show={this.state.show}
                title="¿Te gustaría?"
                text={this.props.message}
                type='warning'
                confirmButtonText="Si"
                cancelButtonText="No"
                showCancelButton
                confirmButtonColor='#00D1C0'
                onConfirm={() => {
                    this.setState({ show: false });
                    // eslint-disable-next-line
                    this.props.callbackConfirm(this.state.id);
                }}
                onCancel={() => {
                    this.setState({ show: false });
                }}
            />
        );
    }
}
export default QuestionDialog;



// WEBPACK FOOTER //
// ./src/components/extras/QuestionDialog.js